import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import LoginContainer from '../containers/LoginContainer';
// import HomeContainer from '../containers/HomeContainer';
import SideMenu from '../containers/MenuContainer';
import AdminManagementContainer from '../containers/AdminManagementContainer';
import AdminCreateContainer from '../containers/AdminCreateContainer';
import AdminEditContainer from '../containers/AdminEditContainer';
import LogsContainer from '../containers/LogsContainer';
import AdminUpdatePasswordContainer from '../containers/AdminUpdatePasswordContainer';
import UserManagementContainer from '../containers/UserManagementContainer';
import UserCreateContainer from '../containers/UserCreateContainer';
import UserEditContainer from '../containers/UserEditContainer';

import "../App/App.css"

const App = () => {
  const location = useLocation();
  const hideMenu = location.pathname === '/login';

  return (
    <div className="main-container">
      {!hideMenu && <SideMenu/>}
      <Routes>
        <Route path="/login" element={<LoginContainer />} />

        <Route path="/" element={
          <PrivateRoute>
            <Navigate to="/admin-list" replace />
          </PrivateRoute>
        } />

        <Route path="/admin-list" element={
          <PrivateRoute>
            <AdminManagementContainer />
          </PrivateRoute>
        } />

        <Route path="/admin-list/create" element={
          <PrivateRoute>
            <AdminCreateContainer />
          </PrivateRoute>
        } />

        <Route path="/admin-list/edit/:adminId" element={
          <PrivateRoute>
            <AdminEditContainer />
          </PrivateRoute>
        } />

        <Route path="/logs-view" element={
          <PrivateRoute>
            <LogsContainer />
        </PrivateRoute>
        } />
        
        <Route path="/admin-list/edit/:adminId/password-edit" element={
          <PrivateRoute>
            <AdminUpdatePasswordContainer />
          </PrivateRoute>
        } />

        <Route path="/user-list" element={
          <PrivateRoute>
            <UserManagementContainer />
          </PrivateRoute>
        } />

        <Route path="/user-list/create" element={
          <PrivateRoute>
            <UserCreateContainer />
          </PrivateRoute>
        } />

        <Route path="/user-list/edit/:userId" element={
          <PrivateRoute>
            <UserEditContainer />
          </PrivateRoute>
        } />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);

export default AppWrapper;
